export default __webpack_public_path__ + "static/media/Al-pastor.d0551802.png";